import type { CaseDetailResult } from "@/lib/api";

export type ResolvedCaseEntitlements = {
  court_pdf: boolean;
  mail_filing: boolean;
  premium_defense: boolean;
  records_request: boolean;
};

const isTrue = (value: unknown): boolean => value === true;

export const resolveCaseEntitlements = (caseDetail: CaseDetailResult | null | undefined): ResolvedCaseEntitlements => {
  if (!caseDetail) {
    return {
      court_pdf: false,
      mail_filing: false,
      premium_defense: false,
      records_request: false,
    };
  }

  const root = caseDetail.product_entitlements ?? {};
  const premiumStatus = caseDetail.premium_status?.product_entitlements ?? {};
  const artifact = caseDetail.artifact_status ?? {};

  const premium = isTrue(root.premium_defense) || isTrue(premiumStatus.premium_defense) || isTrue(caseDetail.premium_status?.unlocked);

  const courtPdf = premium || isTrue(root.court_pdf) || isTrue(premiumStatus.court_pdf) || isTrue((artifact as { pdf?: { purchased?: boolean } }).pdf?.purchased);
  const records =
    premium ||
    isTrue(root.records_request) ||
    isTrue(premiumStatus.records_request) ||
    isTrue((artifact as { records?: { purchased?: boolean } }).records?.purchased);
  const mail =
    premium ||
    isTrue(root.mail_filing) ||
    isTrue(premiumStatus.mail_filing) ||
    isTrue((artifact as { mail?: { purchased?: boolean } }).mail?.purchased);

  return {
    court_pdf: courtPdf,
    mail_filing: mail,
    premium_defense: premium,
    records_request: records,
  };
};
